import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=2db81d3a&"
import script from "./LogoutModal.vue?vue&type=script&lang=js&"
export * from "./LogoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports